export default "__VITE_ASSET__xLMozsFZ__"